import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, EMPLOYER, JOB_HIRING_TAG } from "../../../common/URLs";

export const UrgentHiringTag = async (uuid, urgent_hiring_tag) => {
    try {
        const token = await fetchToken()

        const response = await fetch(`${BASE_URL}/${EMPLOYER}/${JOB_HIRING_TAG}/${uuid}`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ urgent_hiring_tag }) // Include the tag in the request body
        });

        // console.log("response in api", response)

        if (!response.ok) {
            throw new Error("Failed");
        }

        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error(error);
    }
};